import axios from 'axios';
import { getAuthToken } from '../utils/auth';

const API_URL = process.env.NODE_ENV === 'development' 
  ? 'http://localhost:8080/api'
  : '/api';

console.log('API URL configured as:', API_URL);

// Configure axios defaults
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.timeout = 30000; // 30 seconds

// Add auth token to all requests
axios.interceptors.request.use(request => {
  const token = getAuthToken();
  if (token) {
    request.headers.Authorization = `Bearer ${token}`;
  } else {
    console.warn('No auth token found');
  }
  console.log('Starting Request:', {
    url: request.url,
    method: request.method,
    data: request.data
  });
  return request;
});

// Add response interceptor for debugging
// axios.interceptors.response.use(
//   response => {
//     console.log('Response:', {
//       status: response.status,
//       data: response.data,
//       url: response.config.url
//     });
//     return response;
//   },
//   error => {
//     console.error('Request Error:', {
//       message: error.message,
//       response: error.response?.data,
//       status: error.response?.status,
//       url: error.config?.url
//     });
//     return Promise.reject(error);
//   }
// );

// Start a new interview
export const startInterview = async (config) => {
  try {
    console.log('Starting interview with config:', config);
    console.log('API URL:', `${API_URL}/interviews`);
    
    // Verify all required config options are present
    const requiredConfig = ['difficulty', 'questionType', 'industry', 'caseType', 'interviewStyle'];
    const missingParams = requiredConfig.filter(param => !config[param]);
    
    if (missingParams.length > 0) {
      throw new Error(`Missing required parameters: ${missingParams.join(', ')}`);
    }
    
    const response = await axios.post(`${API_URL}/interviews`, config);
    console.log('Interview started successfully:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error starting interview:', error);
    throw error;
  }
};

export const sendMessage = async (interviewId, message) => {
  try {
    // Verify this is the current interview
    const currentInterview = sessionStorage.getItem('currentInterview');
    if (currentInterview !== interviewId) {
      throw new Error('Interview session mismatch');
    }

    const response = await axios.post(
      `${API_URL}/interviews/${interviewId}/message`,
      { content: message }
    );

    return {
      message: response.data.message
    };
  } catch (error) {
    console.error('Error sending message:', error);
    throw error;
  }
};

export const getInterview = async (interviewId) => {
  try {
    const response = await axios.get(
      `${API_URL}/interviews/${interviewId}`
    );
    return response.data;
  } catch (error) {
    console.error('Error getting interview:', error);
    throw error;
  }
};

export const getInterviewStatus = async (interviewId) => {
  try {
    const response = await axios.get(
      `${API_URL}/interviews/${interviewId}/status`
    );
    return response.data;
  } catch (error) {
    console.error('Error getting interview status:', error);
    throw error;
  }
};

export const toggleInterviewPause = async (interviewId) => {
  try {
    const response = await axios.post(
      `${API_URL}/interviews/${interviewId}/pause-resume`,
      {} // Empty body but needed for POST
    );
    return response.data;
  } catch (error) {
    console.error('Error toggling interview pause:', error);
    throw error;
  }
};

export const endInterview = async (interviewId) => {
  try {
    const response = await axios.post(`${API_URL}/interviews/${interviewId}/end`);
    return response.data;
  } catch (error) {
    console.error('Error ending interview:', error);
    throw error;
  }
}; 